const ibuAnak: any = {
	kehamilan: {
		title: 'Informasi Kehamilan Terlengkap',
		description:
			'Informasi lengkap seputar kehamilan, Mulai dari Program Hamil, Perkembangan Janin, ' +
			'Seputar Kandungan sampai Proses Melahirkan hanya di KlikDokter.',
	},
	'ibu-menyusui': {
		title: 'Informasi ASI dan Ibu Menyusui  Terlengkap',
		description:
			'Informasi lengkap seputar fakta ASI dan tips menyusui yang perlu Ibu ketahui hanya ' +
			'di KlikDokter.',
	},
	'kesehatan-bayi': {
		title: 'Informasi Kesehatan Bayi Terlengkap',
		description:
			'Informasi lengkap mengenai pertumbuhan, perkembangan kebutuhan gizi MPASI, ' +
			'dan gangguan kesehatan pada bayi (0-12 bulan)  ',
	},
	'kesehatan-balita': {
		title: 'Informasi Kesehatan Balita Terlengkap',
		description:
			'Informasi lengkap mengenai pertumbuhan, perkembangan kebutuhan gizi, dan gangguan ' +
			'kesehatan pada balita (1- 5 tahun).',
	},
	'kesehatan-anak': {
		title: 'Informasi Kesehatan Anak Terlengkap',
		description:
			'Informasi lengkap mengenai pertumbuhan, perkembangan, kebutuhan gizi, ' +
			'gangguan kesehatan pada anak  dan remaja hanya di KlikDokter.',
	},
	'tips-parenting': {
		title: 'Informasi Parenting Terlengkap',
		description:
			'Informasi lengkap seputar tips parenting mudah yang perlu diketahui orangtua serta ' +
			'masalah parenting yang kerap terjadi hanya di KlikDokter.',
	},
};

export default ibuAnak;
